// src/models/auth.model.ts
import * as z from "zod/mini";
import { UserDataSchema, orDefault } from "./user.model.ts";

export const RegisterResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: orDefault(z.string(), (v) => v ?? ""),
  user: UserDataSchema,
});

export type RegisterResponse = z.infer<typeof RegisterResponseSchema>;
